import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const TabPanel = ({ element, children, className, active, ...rest }) => {
  const Element = element

  return (
    <Element
      {...rest}
      role="tabpanel"
      aria-hidden={!active}
      className={classnames(className, !active && 'ln-u-hidden')}
    >
      {children}
    </Element>
  )
}

TabPanel.propTypes = {
  element: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object,
  ]),
  children: PropTypes.node,
  className: PropTypes.string,
  active: PropTypes.bool,
}

TabPanel.defaultProps = {
  element: 'div',
  children: undefined,
  className: undefined,
  active: true,
}

TabPanel.displayName = 'TabPanel'

export default TabPanel
